import {useMutation, useQueryClient} from '@tanstack/react-query'

import {updateDecisionMatrix} from './api'
import {creditDecisionKeys} from './keys'
import type {CreditDecisionData, CreditDecisionResponse} from './types'

export const useUpdateCreditDecisionMatrix = () => {
  const queryClient = useQueryClient()

  return useMutation<CreditDecisionResponse, unknown, CreditDecisionData>({
    mutationFn: updateDecisionMatrix,
    onSuccess: data => {
      if (data.companyId) {
        queryClient.invalidateQueries({queryKey: creditDecisionKeys.detail(data.companyId)})
        queryClient.invalidateQueries({queryKey: creditDecisionKeys.lists()})
      }
    },
  })
}
